__turbopack_context__.v({
  "group": "groupedSelect-module-scss-module__9jTNsW__group",
  "groupHeader": "groupedSelect-module-scss-module__9jTNsW__groupHeader",
  "multiValueWrp": "groupedSelect-module-scss-module__9jTNsW__multiValueWrp",
  "option": "groupedSelect-module-scss-module__9jTNsW__option",
  "selectedOption": "groupedSelect-module-scss-module__9jTNsW__selectedOption",
});
